import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import classnames from 'classnames';
import FrCheckSvg from '@src/svgs/fr-check.svg';
import { HOW_VIRTUAL_RECRUITER_WORKS_URL } from '@src/constants';
import { SilentDialog } from '@src/components/SilentDialog';
import { Appearance, Button } from '@src/components/Button';
import { MetricContext, MetricEventSource } from '@src/metrics/metrics.enum';
import { NEW_FUNNEL_ROUTE } from '@src/Routes/links';
import { trackViewCreateTargeting } from '@src/metrics';
import { ConfirmMessageProps } from './props';
import './styles.scss';

export const ConfirmMessage: FC<ConfirmMessageProps> = ({ isActive, onContinue }) => {
  const openingBenefits = [
    'Get higher response rates if you attach a job opening to your message',
    'Reach 150k “passive” talents who are not currently active on the market',
    'Deliver your opening instantly to best matches via notifications',
    'Reuse the outgoing message and describe the job in more detail',
    <>
      Get access to MeetFrank{' '}
      <a href={HOW_VIRTUAL_RECRUITER_WORKS_URL} target="_blank" rel="noreferrer">
        Virtual Agency
      </a>{' '}
      to help with your hiring and outreach.
    </>,
  ];

  return (
    <div className={classnames('candidate-confirm-message', isActive && 'candidate-confirm-message--active')}>
      <Svg className="candidate-confirm-message__success-icon" src={FrCheckSvg} />

      <h3>Message sent successfully!</h3>

      <div className="candidate-confirm-message__opening-wrapper">
        <div className="candidate-confirm-message__opening-title">Would you like to add a Job Opening?</div>

        {openingBenefits.map((text, index) => (
          <SilentDialog
            className="candidate-confirm-message__item"
            iconWrapperClassName="candidate-confirm-message__item-icon"
            icon={FrCheckSvg}
            key={index}
            text={text}
          />
        ))}

        <Button
          appearance={Appearance.PRIMARY}
          isLink
          className="candidate-confirm-message__opening-button"
          onClick={() =>
            trackViewCreateTargeting({
              'Event Source': MetricEventSource.VIEW_TALENT_AGENT_USER_MODAL,
              'Previous Context': MetricContext.OPENINGS_PAGE,
            })
          }
          to={NEW_FUNNEL_ROUTE}
        >
          Add a job opening
        </Button>
      </div>

      <Button
        className="candidate-confirm-message__continue-button"
        appearance={Appearance.INVISIBLE}
        onClick={() => onContinue?.()}
      >
        Continue browsing
      </Button>
    </div>
  );
};
